

if($('.id--16').length){
    function zkontrolujSlevovyKod() {
        var dataLayer = getShoptetDataLayer('cartInfo');
        if (dataLayer && dataLayer.discountCoupon && dataLayer.discountCoupon.code) {
            var kod = dataLayer.discountCoupon.code;
            if (vyluc_slevove_kody.includes(kod)) {
                var $dobirka = $('#order-billing-methods .radio-wrapper[data-id="billing-' + id_Dobirky + '"]');
                if ($dobirka.length) {
                    $dobirka.addClass('inactive-child');
                    $dobirka.find('label').addClass('inactive');
                    $dobirka.find('input').attr('disabled', true);
                    $dobirka.find('.payment-info em').text(text_dobirka)
                }
            }
        }
    }
    $(document).ready(function(){
        zkontrolujSlevovyKod()
    })
    document.addEventListener('ShoptetBillingMethodUpdated', function() {
        zkontrolujSlevovyKod();
    });
    
}